import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import {
  numberToLong2pakxeg38estk as numberToLong,
  toNumber2e2hj9zugjwi2 as toNumber,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ extends ExcelValue() {
      constructor() {
        Empty_instance = null;
        super();
        Empty_instance = this;
      }
      toString() {
        return 'Empty';
      }
      hashCode() {
        return -1984782327;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Empty()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Empty');
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  if (Empty_instance === VOID)
    new (Empty())();
  return Empty_instance;
}
var NumberClass;
function Number_0() {
  if (NumberClass === VOID) {
    class $ extends ExcelValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'Number(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Number_0()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Number');
    NumberClass = $;
  }
  return NumberClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ extends ExcelValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'Text(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Text()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var BoolClass;
function Bool() {
  if (BoolClass === VOID) {
    class $ extends ExcelValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'Bool(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getBooleanHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Bool()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Bool');
    BoolClass = $;
  }
  return BoolClass;
}
var DateClass;
function Date_0() {
  if (DateClass === VOID) {
    class $ extends ExcelValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'Date(value=' + this.value_1.toString() + ')';
      }
      hashCode() {
        return this.value_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Date_0()))
          return false;
        if (!this.value_1.equals(other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Date');
    DateClass = $;
  }
  return DateClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ extends ExcelValue() {
      constructor(code, message) {
        message = message === VOID ? '' : message;
        super();
        this.code_1 = code;
        this.message_1 = message;
      }
      toString() {
        return 'Error(code=' + this.code_1 + ', message=' + this.message_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.code_1);
        result = imul(result, 31) + getStringHashCode(this.message_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Error_0()))
          return false;
        if (!(this.code_1 === other.code_1))
          return false;
        if (!(this.message_1 === other.message_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
var ExcelValueClass;
function ExcelValue() {
  if (ExcelValueClass === VOID) {
    class $ {
      display_rnbphe_k$() {
        var tmp;
        if (this instanceof Empty()) {
          tmp = '';
        } else {
          if (this instanceof Number_0()) {
            tmp = formatNumber(this.value_1);
          } else {
            if (this instanceof Text()) {
              tmp = this.value_1;
            } else {
              if (this instanceof Bool()) {
                tmp = this.value_1 ? 'TRUE' : 'FALSE';
              } else {
                if (this instanceof Date_0()) {
                  tmp = this.value_1.toString();
                } else {
                  if (this instanceof Error_0()) {
                    tmp = '#' + this.code_1 + '!';
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
        return tmp;
      }
      userError_57tibh_k$() {
        var tmp;
        if (this instanceof Error_0()) {
          var tmp_0;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = this.message_1;
          if (!isBlank(this_0)) {
            tmp_0 = this.message_1;
          } else {
            tmp_0 = friendlyMessage(this.code_1);
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ExcelValue');
    ExcelValueClass = $;
  }
  return ExcelValueClass;
}
function asBool(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Bool()) {
    tmp = _this__u8e3s4;
  } else {
    if (_this__u8e3s4 instanceof Number_0()) {
      tmp = new (Bool())(!(_this__u8e3s4.value_1 === 0.0));
    } else {
      if (_this__u8e3s4 instanceof Error_0()) {
        tmp = _this__u8e3s4;
      } else {
        tmp = new (Error_0())('VALUE', 'Expected a boolean but found ' + _this__u8e3s4.display_rnbphe_k$());
      }
    }
  }
  return tmp;
}
function compareValues(a, b) {
  if (a instanceof Error_0())
    return to(0, a);
  if (b instanceof Error_0())
    return to(0, b);
  var tmp;
  if (a instanceof Date_0()) {
    tmp = b instanceof Date_0();
  } else {
    tmp = false;
  }
  if (tmp) {
    return to(a.value_1.compareTo_e7gwgq_k$(b.value_1), null);
  }
  var aNum = asNumber(a);
  var bNum = asNumber(b);
  var tmp_0;
  if (aNum instanceof Number_0()) {
    tmp_0 = bNum instanceof Number_0();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    return to(compareTo(aNum.value_1, bNum.value_1), null);
  }
  var tmp_1;
  if (a instanceof Text()) {
    tmp_1 = b instanceof Text();
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    return to(compareTo(a.value_1, b.value_1), null);
  }
  var err = new (Error_0())('VALUE', 'Cannot compare ' + a.display_rnbphe_k$() + ' with ' + b.display_rnbphe_k$());
  return to(0, err);
}
function asNumber(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Number_0()) {
    tmp = _this__u8e3s4;
  } else {
    if (_this__u8e3s4 instanceof Bool()) {
      tmp = new (Number_0())(_this__u8e3s4.value_1 ? 1.0 : 0.0);
    } else {
      if (_this__u8e3s4 instanceof Text()) {
        // Inline function 'kotlin.text.trim' call
        var this_0 = _this__u8e3s4.value_1;
        var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        var tmp1_safe_receiver = toDoubleOrNull(tmp$ret$0);
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = new (Number_0())(tmp1_safe_receiver);
        }
        var tmp2_elvis_lhs = tmp_0;
        tmp = tmp2_elvis_lhs == null ? new (Error_0())('VALUE', "Could not convert text to a number: '" + _this__u8e3s4.value_1 + "'") : tmp2_elvis_lhs;
      } else {
        if (_this__u8e3s4 instanceof Error_0()) {
          tmp = _this__u8e3s4;
        } else {
          tmp = new (Error_0())('VALUE', 'Expected a number but found ' + _this__u8e3s4.display_rnbphe_k$());
        }
      }
    }
  }
  return tmp;
}
function asText(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Empty()) {
    tmp = '';
  } else {
    if (_this__u8e3s4 instanceof Number_0()) {
      tmp = formatNumber(_this__u8e3s4.value_1);
    } else {
      if (_this__u8e3s4 instanceof Text()) {
        tmp = _this__u8e3s4.value_1;
      } else {
        if (_this__u8e3s4 instanceof Bool()) {
          tmp = _this__u8e3s4.value_1 ? 'TRUE' : 'FALSE';
        } else {
          if (_this__u8e3s4 instanceof Date_0()) {
            tmp = _this__u8e3s4.value_1.toString();
          } else {
            if (_this__u8e3s4 instanceof Error_0()) {
              tmp = '#' + _this__u8e3s4.code_1 + '!';
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function formatNumber(d) {
  if (isNaN_0(d) || isInfinite(d))
    return d.toString();
  var tmp;
  // Inline function 'kotlin.math.floor' call
  if (d === Math.floor(d)) {
    // Inline function 'kotlin.math.abs' call
    tmp = Math.abs(d) < 1.0E15;
  } else {
    tmp = false;
  }
  if (tmp)
    return numberToLong(d).toString();
  return d.toString();
}
function friendlyMessage(code) {
  switch (code) {
    case 'DIV/0':
      return 'Division by zero';
    case 'VALUE':
      return "A value in this formula isn't the right type";
    case 'NAME':
      return "A name in this formula isn't recognized";
    case 'NUM':
      return 'The calculation produced an invalid number';
    case 'N/A':
      return 'No matching value was found';
    default:
      return 'An error occurred (#' + code + '!)';
  }
}
function toExcelValue(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 == null) {
    tmp = Empty_getInstance();
  } else {
    if (_this__u8e3s4 instanceof ExcelValue()) {
      tmp = _this__u8e3s4;
    } else {
      if (typeof _this__u8e3s4 === 'number') {
        tmp = new (Number_0())(_this__u8e3s4);
      } else {
        if (typeof _this__u8e3s4 === 'bigint') {
          tmp = new (Number_0())(toNumber(_this__u8e3s4));
        } else {
          if (typeof _this__u8e3s4 === 'number') {
            tmp = new (Number_0())(_this__u8e3s4);
          } else {
            if (typeof _this__u8e3s4 === 'number') {
              tmp = new (Number_0())(_this__u8e3s4);
            } else {
              if (typeof _this__u8e3s4 === 'boolean') {
                tmp = new (Bool())(_this__u8e3s4);
              } else {
                if (typeof _this__u8e3s4 === 'string') {
                  tmp = new (Text())(_this__u8e3s4);
                } else {
                  if (_this__u8e3s4 instanceof LocalDate()) {
                    tmp = new (Date_0())(_this__u8e3s4);
                  } else {
                    if (typeof _this__u8e3s4 === 'number') {
                      tmp = new (Number_0())(_this__u8e3s4);
                    } else {
                      if (typeof _this__u8e3s4 === 'number') {
                        tmp = new (Number_0())(_this__u8e3s4);
                      } else {
                        tmp = new (Error_0())('VALUE', 'Unsupported variable type: ' + getKClassFromExpression(_this__u8e3s4).get_simpleName_r6f8py_k$());
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
//region block: exports
export {
  Empty_getInstance as Empty_getInstancey576bdifk14w,
  Bool as Bool1r3p37fvso3wz,
  Date_0 as Date2m34sotjh4dpv,
  Empty as Empty2w0k1znsc32mg,
  Error_0 as Error21zp7h9320rwp,
  Number_0 as Number6kmrfn4klz39,
  Text as Text2b8ye3kmips1o,
  asBool as asBool20p924j1rdl68,
  asNumber as asNumber3rgwwt2ok3oo4,
  asText as asTextufk6946h4qqq,
  compareValues as compareValues1f9uh3diuktj1,
  toExcelValue as toExcelValue3gg0xp798altl,
};
//endregion

//# sourceMappingURL=ExcelValue.mjs.map
